var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_231)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.586 17.417h5.5v1.833H6.419a.917.917 0 000 1.833h9.167a.917.917 0 000-1.833h-3.667v-1.833h5.5a4.592 4.592 0 004.492-3.667H.094a4.592 4.592 0 004.492 3.667zM17.42.917H4.585A4.589 4.589 0 00.002 5.5v6.416h22V5.5A4.589 4.589 0 0017.42.917z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_231"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.002)",
    d: "M0 0h22v22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.2f16f899e7af027e97a68c0c1294d996.svg";
export { ForwardRef as ReactComponent };